import { type ReactNode } from 'react';

import { Map } from '@/microfrontends/map/shared';

import { MapBanners } from '@/packages/MapBanners';
import { useUserQuery } from '@/packages/query-state/shared/store/monolith-python/cian-api/site/v1/get-user-data-by-request/query';
import { useFiltersSelector } from '@/packages/redux-state/store/slices/jsonQuery';
import { useListingLayoutViewModeSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';

import { useApplicationContext } from '../../context/ApplicationContext';
import { useElementsRefContext } from '../../context/ElementsRefContext';

import { MapLayout } from './internal/components/MapLayout';
import { useCalculateMapSizes } from './internal/hooks/useCalculateMapSizes';

export function MapLayoutContainer(): ReactNode {
  const context = useApplicationContext();

  const { mapContainerRef } = useElementsRefContext();

  const { data: user } = useUserQuery();

  const jsonQuery = useFiltersSelector();

  const viewMode = useListingLayoutViewModeSelector();

  useCalculateMapSizes();

  return (
    <MapLayout
      banners={<MapBanners jsonQuery={jsonQuery} userIsAgent={user?.isAgent} />}
      fullscreen={viewMode === 'map'}
      map={<Map context={context} />}
      ref={mapContainerRef}
    />
  );
}
